import { render, staticRenderFns } from "./AttachedDocumentList.vue?vue&type=template&id=0acab92e&scoped=true&"
import script from "./AttachedDocumentList.vue?vue&type=script&lang=js&"
export * from "./AttachedDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acab92e",
  null
  
)

export default component.exports